export const VentActionTypes = {
    SET_VENT_POSITIVE: 'SET_VENT_POSITIVE',
    SET_VENT_NEGATIVE: 'SET_VENT_NEGATIVE'
}
